import http from "@/lib/api";
import { toast } from "sonner";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function enablePushNotifications() {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      toast.error("Nettleseren støtter ikke push-varsler");
      return false;
    }
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      toast.error("Varsler ble ikke tillatt");
      return false;
    }
    const reg = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;
    const { data } = await http.get("/v1/admin/push/public-key");
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
    await http.post("/v1/admin/push/subscribe", { subscription: sub.toJSON() });
    toast.success("Push-varsler aktivert / Уведомления включены");
    return true;
  } catch (e) {
    toast.error("Kunne ikke aktivere varsler");
    return false;
  }
}
